<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <modal-link modal-id="How to Use" :content-list="pageContent"></modal-link>Explore
      <smart-center-link page="Explore" location="Header" />
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()"
          class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()"
          class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <div class="chart-app">
      <chart-criteria ref="chartCriteria" showUseTTMAsStartDate="true" :show-custom-time-period="false" :show-metric="true" :show-display-type="true" @reset-client-chart="resetClientChart"  @reset-sub-chart-criteria="resetSubChartCriteria" is-explore-page="true"
        display-type-label="Explore" display-type-modal-name="Explore" time-period-label="Start Period" :is-comparative="false" :show-end-period="true"></chart-criteria>
      <div class="row no-gutters">
        <div class="col-12">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <chart-display-skeleton v-show="generatingChart"/>
              <div id="chart-filters" class="row">
                <chart-criteria-results ref="chartCriteriaResults" v-bind:criteria-results-list="criteriaResultsList"
                  v-show="!generatingChart && displayChartCriteriaResults"
                  v-bind:criteria-results-company-list="criteriaResultsCompanyList"></chart-criteria-results>
              </div>
              <MoatTrend v-show="isMoatTrend  && !generatingChart" :chart-data="chartData"></MoatTrend>
              <div v-show="!isMoatTrend" id="chart-container" class="by-value">
                <div id="competitive-trends-chart" class="chart-row" v-show="getDisplayView()">
                  <profile-chart-header
                      :content-list="pageContent"
                      :content-name="'Explore'"
                      :title="chart.title + ' | ' + titleSuffix"
                      :input-display-number-of-responses="eChartCriteria.displayNumberOfResponses"
                      :input-show-tooltip="eChartCriteria.showTooltip"
                      @set-display-number-of-responses="setDisplayNumberOfResponses"
                      @set-show-tooltip="setShowTooltip"
                  />
                  <trends-chart ref="eChart"
                      v-show="!showNpsTrends()"
                      :display-chart="!showNpsTrends()"
                      :e-chart-mini-id="'trends-chart-mini'"
                      :e-chart-id="'trends-chart'"
                      :input-report-type-name="'Chart - Competitive Trends'"
                      :modal-id="'competitive-trends-chart'"
                      :is-saved-card="this.clientChart.clientChartId != 0" 
                      :input-client-chart="this.clientChart"
                      :inputDownloadFileName="this.chart.title + ' ' + titleSuffix"
                      :focus-area="focusArea"
                      @save-table="saveProfileDataTable"
                      @save-criteria="buildClientChart"/>

                  <NPS-chart ref="npsChart"
                      v-show="showNpsTrends()"
                      :e-chart-mini-id="'nps-chart-mini'"
                      :e-chart-id="'nps-chart'"
                      :is-match="true"
                      :display-title="false"
                      :input-report-type-name="'Chart - Competitive Trends'"
                      :modal-id="'competitive-trends-chart'"
                      :input-client-chart="this.clientChart"
                      :is-saved-card="this.clientChart.clientChartId != 0" 
                      @save-table="saveProfileDataTable"
                      @save-criteria="buildClientChart"/>                                          
                </div>
                <div class="chart-row pt-3 w-100" v-show="!showNpsTrends() && getDisplayView() && showRanksByGroup">
                  <ranks-by-group ref="ranksByGroup" :survey-group-options="surveyGroupOptions" :entry-survey-code="this.surveyCode" :client-object="this.clientObject" :auto-generate-ranks-by-group="autoGenerateChart" :client-chart="this.clientChart" @save-ranks-by-group-criteria="handleSaveRanksByGroupCriteria"></ranks-by-group>      
                  <download-comments ref="downloadComments" :debug-mode="false" :entry-survey-code="this.surveyCode" :client-object="this.clientObject" :is-explorer-page="true" :auto-generate-verbatims="autoGenerateChart" :client-chart="this.clientChart" @save-download-comments-criteria="handleSaveDownloadCommentsCriteria" :need-name="this.displayType" :top-result-dt-columns="this.topResultDtColumns"></download-comments>
                </div>
                <div v-show="!showNpsTrends() && getDisplayView()" :id="tableContainerId"
                  :class="isInsiderUser ? 'chart-data hide-table-data' : 'chart-data'">
                  <div v-show="isInsiderUser" class="overlay">
                    <img class="overlay-inner" v-show="isInsiderUser" src="../../assets/img/overlap.png"  style="width: 50%"/>
                  </div>
                  <chart-data-table 
                    ref="competitiveTrendsDataTable"
                    :use-alternate-title="true"
                    :chart-data="table.data" :container-id="'competitive-trends'"
                    :is-saved-card="this.clientChart.clientChartId != 0" 
                    :data-container-id="tableContainerId" :column-defs="this.chart.columnDefs"
                    :table-class="'table display row-border table-hover'" :table-width="'auto'"
                    :table-title="tableTitle" :report-page-type-name="'Table - Competitive Trends'"
                    :insight-modal-id="'competitive-trends-table'"
                    :inputDownloadFileName="this.chart.title + ' ' + titleSuffix"
                    :display-profile-strength-legend="displayProfileStrengthLegend"
                    >
                  </chart-data-table>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
        <modal :modal-id="pageContent.title" :modal-title="pageContent.title"
          :modal-content="pageContent.contentText" />
      </div>
      <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
        <save-chart :chart-title="this.chart.title" :initial-client-chart="this.clientChart"
          @save="updateClientCharts" @closeModal="closeModal('save-chart-confirmation')"></save-chart>
      </vue-modal>
      <insights ref="insightsChart" :modal-name="'competitive-trends-chart'"
        :report-page-type-name="'Chart - Competitive Trends'" :entry-page-content="this.pageContentForReport"
        @saveReportPage="updateReportPages" @saveAllReportPages="saveAllReportPages"
        @saveClientChart="saveClientChart" />
      <insights ref="insightsTable" :modal-name="'competitive-trends-table'"
        :report-page-type-name="'Table - Competitive Trends'" :entry-page-content="this.pageContentForReport"
        @saveReportPage="updateReportPages" @saveAllReportPages="saveAllReportPages"
        @saveClientChart="saveClientChart" />
    </div>
  </div>
</template>
<script>
import $ from "jquery";

import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import MoatTrend from "./type/MoatTrend.vue";

import ProfileChartHeader from "../../components/echarts/ProfileChartHeader.vue";
import TrendsChart from "../../views/echarts/TrendsChart.vue";
import NPSChart from "../../views/echarts/NPSChart.vue";

import SaveChart from "../../components/chart/SaveChart.vue";
import RanksByGroup from "../../components/chart/RanksByGroup.vue";
import DownloadComments from "../../components/chart/DownloadComments.vue";

import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import AdminService from "../../services/admin.service";
import TableService from "../../services/table.service";
import ReportService from "../../services/report.service";
import TrendsService from "../../services/echarts/trends.service";

export default {
  name: "CompetitiveTrends",
  mixins: [ChartCompanyMixins],
  components: {
    SaveChart,
    MoatTrend,
    TrendsChart,
    NPSChart,
    ChartDisplaySkeleton,
    ProfileChartHeader,
    RanksByGroup,
    DownloadComments
  },
  data() {
    return {
      title: "Trends",
      displayType: "trends",
      defaultClientChartName: "",
      tableContainerId: "competitive-trends-data-container",
      pageNumber: 3,
      npsChartDataByTimePeriod: -1,
      chartData: {},
      redrawAdditionalWidgets: true,
      competitiveTrendsOptions: {},
      focusArea: {},
      emotionalNeedSelected: false,
      insightModalId: "",
      excludeMetrics: false,
      isMoatTrend: false,
      displayProfileStrengthLegend: true,
      titleSuffix: "",
      verbatimsCriteria: "",
      ranksByGroupCriteria:"",
      surveyGroupOptions: [],
      topResultDtColumns: TableService.getExploreAITopResultsTableAttributes(),
    };
  },
  methods: {
    resetSubChartCriteria() {
      this.$refs.downloadComments.resetValues();
      this.$refs.ranksByGroup.resetValues();
    },

    handleSaveRanksByGroupCriteria(params) {
      this.ranksByGroupCriteria = params.toString();
      this.buildClientChart();
    },
    handleSaveDownloadCommentsCriteria(params) {
      this.verbatimsCriteria = params.toString();
      this.buildClientChart();
    },
    closeModal(name) {
      if(this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Competitive Trends") {
        this.$refs.insightsChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.reportPagesList);
        this.$refs.insightsChart.initializeInsights(this.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Competitive Trends") {
        this.$refs.insightsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.reportPagesList);
        this.$refs.insightsTable.initializeInsights(this.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    async displayChartCallback(response) {
      try {
        this.$refs.downloadComments.$data.pageContent = this.$refs.chartCriteria.$data.pageContent;
        this.$refs.ranksByGroup.$data.pageContent = this.$refs.chartCriteria.$data.pageContent;

        this.chart = ChartService.getChartAttributes("Explore");
        this.$root.processServerResponse();
        this.generatingChart = false;

        let returnData = response.data;
        this.chartData = returnData[0];
        let chartDataToDisplay = JSON.parse(JSON.stringify(this.chartData));
        let otherData = chartDataToDisplay["otherData"];
        let titleSuffix = otherData["titleSuffix"];
        if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
          this.titleSuffix = titleSuffix;
        }
        let focusArea = otherData["focusArea"];
        if (typeof focusArea != "undefined" && focusArea != null) {
          this.focusArea = focusArea;
        } else {
          this.focusArea = {};
        }
        if (typeof otherData["errorMessage"] != "undefined") {
          AdminService.displayErrorMessage({ text: otherData["errorMessage"] });
          return;
        }
        if (typeof otherData["isMoatTrends"] != "undefined") {
          this.isMoatTrend = otherData["isMoatTrends"];
        } else {
          this.isMoatTrend = false;
        }
        if (this.isMoatTrend) {
          this.displayType = "moat-trends";
          this.chartData = response.data;
          return;
        } else {
          this.displayType = "trends";
        }
        this.excludeMetrics = otherData["excludeMetrics"];
        this.emotionalNeedSelected = otherData["emotionalNeedSelected"];
        let companyColorList = otherData["companyColorList"];
        TableService.setCompanyColorList(companyColorList);
        let breakPointList = otherData["breakPointList"];
        ChartService.setVerticalLineBreakPoints(breakPointList);

        let dynamicChartOptions = chartDataToDisplay["options"];
        this.chart.title = typeof dynamicChartOptions.title != "undefined" ? dynamicChartOptions.title : "Summary";
        let containerId = chartDataToDisplay["containerId"];

        this.criteriaResultsList = AdminService.removeByName(chartDataToDisplay.criteriaList, "Competitor");
        let showRelationshipStrength = this.criteriaResultsList.find(item => item.name === "Show Relative Strength");
        if (typeof showRelationshipStrength != "undefined" && showRelationshipStrength.displayValue == "Yes") {
          this.displayProfileStrengthLegend = true;
        } else {
          this.displayProfileStrengthLegend = false;
        }        
        this.$root.$emit("check-number-of-responses");
        this.setDisplayView(true);
        this.$root.processServerResponse();
        this.setEChartCriteria(this.$refs.chartCriteria.eChartCriteria,false);
        this.buildClientChart();
        this.setDefaultClientChartName();

        if (this.showNpsTrends()) {
          let npsChartDataByTimePeriod = otherData["npsChartDataByTimePeriod"];
          this.npsChartDataByTimePeriod = npsChartDataByTimePeriod;
          this.drawNPSChart();
        } else {
          let calculateWScores = otherData["calculateWScores"];
          let excludeExpectations = otherData["excludeExpectations"];
          let vAxisForMetric = otherData["vAxisForMetric"];
          let isCurrency = false; 
          let formatter = "%";
          if (typeof vAxisForMetric !== 'undefined' && vAxisForMetric !== null ){
            formatter = vAxisForMetric.format;
          }
          let columns = chartDataToDisplay["cols"];
          this.chart.columnDefs = this.getColumnDefs(columns,formatter, calculateWScores,excludeExpectations);
          if (!this.showNpsTrends()) {
            this.setChartResults(chartDataToDisplay.companyList);
            this.table.id = containerId;
            this.table.data = chartDataToDisplay;
            chartDataToDisplay = this.drawTimePeriodName(chartDataToDisplay);
          }
          this.parseForTrends(this.chartData);
          this.$refs.eChart.processChart(true,this.displayType,this.eChartData,this.eChartCriteria,this.emotionalNeedSelected,this.excludeMetrics);
        }
        $("#competitive-trends-chart").addClass("chart-wrapper");
        this.surveyGroupOptions = JSON.parse(JSON.stringify(this.$refs.chartCriteria.surveyGroupList));
        this.displayType = this.$refs.chartCriteria.$data.displayType;
      } catch (err) {
        ErrorService.processException("CompetitiveTrends.displayChartCallback", err, "chart", this);
      }
    },
    setDefaultClientChartName() {
      if (this.saveClientChartObject.clientChartId == 0) {
        this.clientChart.name = this.chart.title + " " + this.$refs.chartCriteria.getPeriodName(this.clientChart.clientTimePeriodId);
      }
    },    
    getColumnDefs(columns, formatter, calculateWScores,excludeExpectations,isPositiveCorrelation = true) {
      let position = 0;
      let columnDefintions = [];

      columnDefintions.push(TableService.getOrderSequence()); // 0 
      columnDefintions.push(TableService.getBaseTableAttribute([position], "dt-left", 70)); // 1 
      position++;
      if (this.excludeMetrics == false){
          let isCurrency = formatter != null && formatter.includes("$");   
          let isPercent = formatter != null && formatter.includes("%");   
          const precision = formatter.includes('.###') ? 3 :
                        formatter.includes('.##') ? 2 :
                        formatter.includes('.#') ? 1 : 0;          
          if (isCurrency){
            columnDefintions.push(TableService.getMoneyTableAttribute([position], "dt-right chart-light-green", 75, 2)); // 2 
          } else if (isPercent){ 
            columnDefintions.push(TableService.getPercentTableAttribute([position], "dt-right chart-light-green", 75, precision)); // 2
          } else {
            columnDefintions.push(TableService.getBaseColumn([position], "dt-right", 75)); // 2
          }    
          position++;
      }
      if (calculateWScores){
        columnDefintions.push(TableService.getPercentTableAttribute([position], "dt-right", 75, 2)); // 3
        position++;
      } else {
        columnDefintions.push(TableService.getNumericTableAttribute([position], "dt-right", 75)); // 3
        position++;
      }
      if (excludeExpectations == false){
        columnDefintions.push(TableService.getNumericTableAttribute([position], "dt-right", 75)); // 4
        position++;
      }
      // Find the first position for Relative Strength and Metric/Growth Ideas/Road Map Initiatives by searching columns
      let startPosition = columns.findIndex(col => col.label == "Relative Strength" || col.label == "Metric" || col.label == "Growth Ideas" || col.label == "Road Map Initiatives");
      // We need to ensure that we test position is at least startPosition
      if (position < startPosition){
        position = startPosition;
      }
      columns.forEach(function(column) {
        if (position >= startPosition){
          if (column.label == "Relative Strength"){
            columnDefintions.push(TableService.getRelativeStrengthTableAttribute([position], "dt-right", 50, 2,isPositiveCorrelation)); // Relative Strength
            position++;
          } else if (column.label == "Metric" || column.label == "Growth Ideas" || column.label == "Road Map Initiatives"){ 
            columnDefintions.push(TableService.getMetricTableAttribute([position], "dt-left", 200, 2));
            position++;
          }
        }
      });
      columnDefintions.push(TableService.getNumericTableAttribute(["_all"], "dt-right", 75));
      return columnDefintions;
    },
    drawNPSChart: function() {
      this.$refs.npsChart.processChart(true,this.npsChartDataByTimePeriod,this.eChartCriteria);
    },
    buildClientChart: function(){
      this.rebuildClientChart(this.clientId );
    },
    rebuildClientChart(client_id) {
      let useSaveParameters = typeof this.clientChart.criteria != undefined && this.clientChart.criteria != "" && this.autoGenerateChartRun;
      const params = useSaveParameters ? new URLSearchParams(this.clientChart.criteria) : this.$refs.chartCriteria.buildUrlParams(client_id);
      this.clientChart.criteria = params.toString();
      if (typeof this.verbatimsCriteria != "undefined" && this.verbatimsCriteria != "") {
        this.clientChart.criteria += "&" + this.verbatimsCriteria;
      }
      if (typeof this.ranksByGroupCriteria != "undefined" && this.ranksByGroupCriteria != "") {
        this.clientChart.criteria += "&" + this.ranksByGroupCriteria;
      }
    },
    parseForTrends:function(inputData){
      let itemsToRemove = {
          lastColumns: 0,
          firstColumns: 0
        };
      let data = {};
      let chart1Data = inputData;
      data = TrendsService.parseData(1,chart1Data,data,itemsToRemove,false);
      data = TrendsService.parseLegendAndColorData(chart1Data,data);
      data = TrendsService.parseAxisData(chart1Data,data);
      this.eChartData = JSON.parse(JSON.stringify(data));
    },    
    saveAllReportPages() {
      this.saveProfileDataTable("competitive-trends");
    },    
    async saveProfileDataTable(containerId) {
      if (this.clientChart.clientChartId != 0  && this.isGenerateReportRunning()) {
          await ReportService.saveReportTableFile(
            this.$refs.competitiveTrendsDataTable.getTableData(),
            "Table - Competitive Trends", 
            this.clientChart, 
            this.saveReportTableFileCallback, 
            this
          );

          await ReportService.saveReportPage(
            this.getReportTableContent(containerId), 
            "Table - Competitive Trends", 
            this.clientChart, 
            this.saveReportPageCallback, 
            this
          );      
      }
    },    
    drawTimePeriodName(inputChartData) {
      for (let indexRows = 0; indexRows < inputChartData.rows.length; indexRows++) {
        let chartDataRow = inputChartData.rows[indexRows].c;
        let value = chartDataRow[0].v;
        if (typeof value != "undefined") {
          let position = value.indexOf("(");
          let firstPart = value.substring(0, position);
          chartDataRow[0].v = firstPart;
        }
      }
      return inputChartData;
    },
    showNpsTrends: function () {
      if (typeof this.$refs.chartCriteria != "undefined" &&
        typeof this.$refs.chartCriteria.showNpsTrends != "undefined") {
        return this.$refs.chartCriteria.showNpsTrends;
      }
      return false;
    },
    setShowTooltip(inputShowTooltip){
      this.eChartCriteria.showTooltip = inputShowTooltip;
      this.$refs.chartCriteria.eChartCriteria.showTooltip = inputShowTooltip;
      if (this.showNpsTrends()) {
          this.drawNPSChart();      
      } else {
        this.$refs.eChart.processChart(true,this.displayType,this.eChartData,this.eChartCriteria,this.emotionalNeedSelected,this.excludeMetrics);
      }
    },
    setDisplayNumberOfResponses(inputDisplayNumberOfResponses){
      this.eChartCriteria.displayNumberOfResponses = inputDisplayNumberOfResponses;
      this.$refs.chartCriteria.eChartCriteria.displayNumberOfResponses = inputDisplayNumberOfResponses;
      if (this.showNpsTrends()) {
          this.drawNPSChart();      
      } else {
        this.$refs.eChart.processChart(true,this.displayType,this.eChartData,this.eChartCriteria,this.emotionalNeedSelected,this.excludeMetrics);
      }
    },    
    processExploreFromProfile(){
      let filteredParameters = ["", "custom_start_date", "custom_end_date", "display_type", "custom_time_period"];
      let competitorFilteredParameters = ["competitor_company_id"];
      let benchmarkFilteredParameters = ["benchmark_company_id"];
      let savedChartFromProfile = this.clientObject.clientCharts.find(
        (chart) => chart.clientChartId === this.saveClientChartIdFromProfile
      );
      if (typeof savedChartFromProfile != "undefined" && typeof savedChartFromProfile.criteria != "undefined" && savedChartFromProfile.criteria != "") {
        let criteriaParameters = savedChartFromProfile.criteria.split("&");
        for (let criteriaIndex = 0; criteriaIndex < criteriaParameters.length; criteriaIndex++) {
          let criteria = criteriaParameters[criteriaIndex];
          let parameters = criteria.split("=");
          if (competitorFilteredParameters.includes(parameters[0])) {
            let competitor = {};
            competitor.id = parameters[1];
            competitor.companyId = parameters[1];
            competitor.checked = true;
            competitor.companyType = "competitor";
            this.$refs.chartCriteria.addCompany(competitor);
            this.$refs.chartCriteria.$data.values.push(competitor);
            var competitorOptionMatch = this.$refs.chartCriteria.$data.competitor_options.find(x => Number(x.companyId) === Number(competitor.companyId));
            if (typeof competitorOptionMatch != "undefined") {
              competitorOptionMatch.checked = true;
            }            
          }
          else if (benchmarkFilteredParameters.includes(parameters[0])) {
            let benchmark = {};
            benchmark.id = parameters[1];
            benchmark.companyId = parameters[1];
            benchmark.checked = true;
            benchmark.companyType = "benchmark";
            this.$refs.chartCriteria.addCompany(benchmark);
          }
          else if (parameters[0] == "show_metric_groups") {
            this.$refs.chartCriteria.$data.metric = parameters[1];
            this.$refs.chartCriteria.saveResultValue(parameters[1], 'Metric', 'metric', true);
          }
          else if (!filteredParameters.includes(parameters[0])) {
            this.processSavedChartCriteria(criteria);
          }
        }
        // set the end date
        // make sure the period is not empty or is a number
        if (this.$refs.chartCriteria.period != "") {
          this.$refs.chartCriteria.endPeriod = this.$refs.chartCriteria.period;
        }
        // make sure the period is not empty or is a number
        if (this.$refs.chartCriteria.startPeriod != "") {
          this.$refs.chartCriteria.period = this.$refs.chartCriteria.startPeriod;
        }
        if (this.$refs.chartCriteria.startPeriod == "") {
          let earliestPeriod = this.$refs.chartCriteria.$data.period_options[this.$refs.chartCriteria.$data.period_options.length - 1].value;
          this.$refs.chartCriteria.startPeriod = earliestPeriod;
          this.$refs.chartCriteria.period = earliestPeriod;
        }
        if (this.$refs.chartCriteria.endPeriod == "") {
          let latestPeriod = this.$refs.chartCriteria.$data.period_options[0].value;
          this.$refs.chartCriteria.endPeriod = latestPeriod;
        }
      } else {
        let earliestPeriod = this.$refs.chartCriteria.$data.period_options[this.$refs.chartCriteria.$data.period_options.length - 1].value;
        let latestPeriod = this.$refs.chartCriteria.$data.period_options[0].value;
        this.$refs.chartCriteria.startPeriod = earliestPeriod;
        this.$refs.chartCriteria.period = earliestPeriod;
        this.$refs.chartCriteria.endPeriod = latestPeriod;
      }      
      this.$refs.chartCriteria.saveTimePeriod(this.$refs.chartCriteria.period, "Period", "period", true);
      this.$refs.chartCriteria.saveResultValue(this.$refs.chartCriteria.endPeriod, "End Period", "endPeriod", true);
      this.$refs.chartCriteria.saveResultValue(this.$refs.chartCriteria.startPeriod, "Start Period", "startPeriod", true);
      this.$refs.chartCriteria.setSurveyCode();          
      this.$refs.chartCriteria.$data.displayType = this.needTypeFromProfile + "-need-" + this.needNumberFromProfile;
      this.displayType = this.needTypeFromProfile + "-need-" + this.needNumberFromProfile; 
      this.$refs.chartCriteria.saveResultValue(this.$refs.chartCriteria.$data.displayType, 'Display Type', 'display_type', true);
      this.displayMainChart();      
    }
  },
  umnounted() { },
  computed: {
    tableTitle: function () {
      return "<div class='title'><h4 class='text-primary'>" + this.chart.title + " " + this.titleSuffix + "</h4></div>";
    },
    showSummarySmartCenterLink: function () {
      return true;
    },
    showRanksByGroup: function(){
      return this.displayType != "nps" && this.displayType != "nps-trends" && this.displayType != "trends"
            && this.displayType != "satisfaction-needs-gap-average" && this.displayType != "emotional-needs-gap-average";
    }
  },
  props: {
    autoGenerateChartFromProfile: {
      type: Boolean,
      default: false
    },
    saveClientChartIdFromProfile: {
      type: Number,
      default: 0
    },
    needNumberFromProfile: {
      type: Number,
      default: 0
    },
    needTypeFromProfile: {
      type: String,
      default: ""
    },
  },
  mounted() {},
  created() {
    this.chart = ChartService.getChartAttributes("Explore");   
  },
  watch: {
    surveyCode: function(newVal, oldVal) {
      this.verbatimsCriteria = "";
      this.ranksByGroupCriteria = "";
    }
  }
};
</script>
